import React from 'react';
import './Popup.css'; // Create a separate CSS file for Popup styles if needed

const Popup = ({ visaDetails, onClose }) => {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="popup-overlay" onClick={handleOverlayClick}>
            <div className="popup">
                <div className="container">
                    <button className="close-button" onClick={onClose}>×</button>
                    <h1>{visaDetails.SOVEREIGNT}</h1>
                    <b>{visaDetails.visaRequired}</b>
                    <p><b>Days Allowed: </b> {visaDetails.daysAllowed || `Check ${visaDetails.SOVEREIGNT}'s website`}</p>
                    <p>{visaDetails.additionalDetails && (
                        <span><b>Additional details:</b> {visaDetails.additionalDetails}</span>
                    )}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Popup;